<template>
  <div>
    <h1> {{ $t('signupPhone.title') }} </h1>
    <form @submit.prevent="handleSubmit">
      <FormInput
        @blur="$v.form.mobilePhone.$touch()"
        id="register-mobile-phone"
        :label="$t('signupPhone.mobile-phone.label')"
        required
        type="tel"
        v-model="form.mobilePhone"
      >
        <template #error v-if="$v.form.mobilePhone.$dirty">
          <template v-if="!$v.form.mobilePhone.required"> {{ $t('signupPhone.mobile-phone.enter-mobile-phone') }} </template>
          <template v-else-if="!$v.form.mobilePhone.valid"> {{ $t('signupPhone.mobile-phone.mobile-phone-invalid') }} </template>
        </template>
      </FormInput>

      <SignupButtons :can-be-submitted="!$v.$invalid" :is-submitting="isSubmitting" />
    </form>
  </div>
</template>

<script>
  import PhoneNumber from 'awesome-phonenumber';
  import { required } from '@byscripts/vuelidate/lib/validators';
  import FormInput from '@/components/Form/FormInput';
  import SignupButtons from '@/components/Signup/SignupButtons';

  export default {
    name: 'SignupPhone',
    components: {
      SignupButtons,
      FormInput,
    },
    data() {
      return {
        form: {
          mobilePhone: this.$store.state.signup.form.mobilePhone,
          country: this.$store.state.signup.form.country,
        },
        isSubmitting: false,
        signupError: false,
      };
    },
    validations: {
      form: {
        mobilePhone: {
          required,
          valid: async (phoneNumber, form) => {
            if (!form.country) {
              return false;
            }

            return (new PhoneNumber(phoneNumber, form.country)).toJSON().valid;
          },
        },
      },
    },
    methods: {
      async handleSubmit() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return this.$addError(this.$t('signupPhone.check-form'));
        }

        try {
          this.isSubmitting = true;
          this.signupError = false;

          const response = await this.$store.dispatch('authCode/sendCodeForSignup', { mobilePhone: this.form.mobilePhone })
          await this.$store.dispatch('signup/saveForm', { form: this.form });
          if (response.code_required === false) {
            await this.$store.dispatch('signup/register');

            return this.$router.push({ name: 'signup-summary' });
          }
          await this.$store.dispatch('signup/goToNextStep');
        } catch (e) {
          this.signupError = true;
        } finally {
          this.isSubmitting = false;
        }
      },
    },
  };
</script>
